import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H3 } from 'UIComponents/elements/headings';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
import { TRIAL_UPGRADE_DAYS_REMAINING_HEADER } from '../../../constants/ErrorBoundaryNames';
import { getDaysLeftInTrialSelector } from '../../../selectors/ActiveTrialsSelectors';
import { withErrorBoundary } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialUpgradeDaysRemainingHeader = ({
  apiName
}) => {
  const upgradeProduct = ApiNameToUpgradeProductMap[apiName];
  let trialId;
  if (upgradeProduct !== undefined) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    trialId = upgradeProductToTrialIds[upgradeProduct];
  }
  const daysLeftInTrial = useSelector(state => {
    return getDaysLeftInTrialSelector(state, trialId);
  });
  return /*#__PURE__*/_jsx(H3, {
    className: "m-top-10 m-bottom-4",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "interstitial.hc0119.whatsMissing",
      options: {
        count: daysLeftInTrial
      }
    })
  });
};
export default withErrorBoundary(TrialUpgradeDaysRemainingHeader, {
  boundaryName: TRIAL_UPGRADE_DAYS_REMAINING_HEADER
});